import { FamilySearchStorageVM, FiltersFormFamily } from 'family/view-models/family-list';
import { Outlet } from 'react-router-dom';
import { FiltersPersonSearch } from 'shell/constants/filters-person-search';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesFamily: FiltersFormFamily = {
  isMunicipality: false,
  codeAnpr: '',
  codeMunicipality: '',
  codeIstat: '',
  page: 0,
  rowsPerPage: 10,
  orders: {},
  searchByFiscalCode: { fiscalCode: '' },
  subjectData: {
    fiscalCode: '',
  },
  identityCard: {
    number: '',
  },
  residencePermit: {
    preccint: '',
    passportNumber: '',
    permitNumber: '',
  },
  openedAccordion: FiltersPersonSearch.Family,
};

export const initialValuesFamilyStorage: FamilySearchStorageVM = {
  filters: initialValuesFamily,
  subject: null,
};

export default function HomePage(): React.ReactElement {
  return (
    <>
      <FilterTableProvider initialValues={initialValuesFamilyStorage}>
        <Outlet />
      </FilterTableProvider>
    </>
  );
}

HomePage.displayName = 'home page component';
